import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../core/models/RouteHelper';
import NotFoundPage from './NotFoundPage';

export type Props = RouteComponentProps<RouteParams>;

export default withRouter(NotFoundPage);
